"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledToolbarContent = exports.StyledToolbarRow = exports.StyledToolbarContainer = void 0;
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
exports.StyledToolbarContainer = (0, styles_1.styled)(material_1.Box) `
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
exports.StyledToolbarRow = (0, styles_1.styled)(material_1.Box) `
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
exports.StyledToolbarContent = (0, styles_1.styled)('div') `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: ${({ theme }) => theme.spacing(1)};
`;
